import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EHeatingType } from '../../../../../../../json_query';
import { changeHeating } from '../../../../../../state/advanced/heating';

import { Heating as HeatingComponent, IHeatingProps } from './heating';

type THeatingStateProps = Pick<IHeatingProps, 'value'>;
type THeatingDispatchProps = Pick<IHeatingProps, 'onChange'>;

export function mapStateToProps(state: IAppState): THeatingStateProps {
  return {
    value: (state.filters.jsonQuery.heating_source_type && state.filters.jsonQuery.heating_source_type.value) || [],
  };
}

export function mapDispatchToProps(dispatch: Dispatch): THeatingDispatchProps {
  return {
    onChange: (status: EHeatingType, value: boolean) => {
      dispatch(changeHeating(status, value));
    },
  };
}

export const Heating = connect(mapStateToProps, mapDispatchToProps)(HeatingComponent);
